import { useContext } from 'react';
import { Box, Heading } from '@zillow/constellation-10';
import { FolderSelector } from '@zg-rentals/satellite-components';

import type { SatelliteConversationFolderTypeV2 } from '@zg-rentals/ts-satellite-client';
import { InboxPageMobileView } from '../../types/InboxPageMobileView';
import StringConstants from '../../constants/StringConstants';
import { AppContext } from '../../contexts/AppContextProvider';
import { InboxPageContext } from '../../contexts/InboxPageContextProvider';
import { isZillow } from '@zg-rentals/multibrand-support';
import RentingBuyingPills from '../RentingBuyingPills';
import { headerWrapperStyles, zillowFolderSelectorStyles, zillowHeaderWrapperStyles } from './styles';

type Props = {
  onFolderChange(selectedOption: SatelliteConversationFolderTypeV2): void;
};

export default function Header({ onFolderChange }: Props): JSX.Element {
  const { brand } = useContext(AppContext);
  const { mobileView, folder } = useContext(InboxPageContext);
  const isZillowBrand = isZillow(brand);

  const handleFolderChange = (selectedOption: SatelliteConversationFolderTypeV2) => {
    onFolderChange(selectedOption);
  };

  const isMessageListView = mobileView === InboxPageMobileView.MessageList;

  return (
    <Box
      asChild
      css={{
        ...headerWrapperStyles,
        display: {
          base: isMessageListView ? 'none' : 'block',
          lg: 'block',
        },
      }}
    >
      <header>
        <Box
          css={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            ...(isZillowBrand ? zillowHeaderWrapperStyles : {}),
          }}
        >
          <Box css={{ display: 'flex', alignItems: 'center' }}>
            <Heading
              level={1}
              fontFamily="heading-alt"
              css={{
                position: 'relative',
                top: '-25',
                textStyle: {
                  lgDown: 'h4',
                  lg: {
                    base: 'h3',
                    _hotpadsTheme: 'h4',
                  },
                },
              }}
            >
              {isZillowBrand ? StringConstants.ZILLOW_APP_TITLE : StringConstants.HOTPADS_APP_TITLE}
            </Heading>

            {isZillowBrand && <RentingBuyingPills />}
          </Box>

          <Box
            css={{
              marginLeft: 'loose',
              ...(isZillowBrand ? zillowFolderSelectorStyles : {}),
            }}
          >
            <FolderSelector
              selectedFolder={folder}
              actions={{ onFolderChange: handleFolderChange }}
              persona="renter"
              brand={brand}
            />
          </Box>
        </Box>
      </header>
    </Box>
  );
}
